import React, { useEffect } from 'react'

// next components
import Head from 'next/head'

// third party components
import { useDispatch } from 'react-redux'

// custom components
import SecondaryLayout from 'components/Layout/SecondaryLayout'
import MainSection from 'components/pages/Dashboard/MainSection'
import TabSection from 'components/pages/Dashboard/TabSection'

// styles
import styles from './index.module.scss'

const Dashbord = () => {
  const dispatch = useDispatch()
  dispatch({ type: 'set', isGetMyNFTs: false })
  dispatch({ type: 'set', isGetListedNFTs: false })
  useEffect(() => {
    dispatch({ type: 'set', isLoading: false })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <div className="g-container">
      <Head>
        <title>Dashboard</title>
        <meta name="description" content="Generated by create next app" />
        <link rel="icon" href="/logo.png" />
      </Head>
      <div className={styles.container}>
        <MainSection />
        <TabSection />
      </div>
    </div>
  )
}

export default Dashbord

Dashbord.getLayout = function getLayout(page) {
  return <SecondaryLayout>{page}</SecondaryLayout>
}
